import { ResourcesHero } from '@/components/resources/ResourcesHero';
import { ResourceCategories } from '@/components/resources/ResourceCategories';
import { WorkflowVideoSection } from '@/components/resources/WorkflowVideoSection';
import { ComplianceGateVideoSection } from '@/components/resources/ComplianceGateVideoSection';
import { IntegrityNewsletter } from '@/components/resources/IntegrityNewsletter';
import { ResourcesDisclaimer } from '@/components/resources/ResourcesDisclaimer';
import { ROICalculator } from '@/components/resources/ROICalculator';
import { SecurityTrustSection } from '@/components/resources/SecurityTrustSection';

const Resources = () => {
  return (
    <>
      <ResourcesHero />
      <ROICalculator />
      <WorkflowVideoSection />
      <ComplianceGateVideoSection />
      <ResourceCategories />
      <SecurityTrustSection />
      <IntegrityNewsletter />
      <ResourcesDisclaimer />
    </>
  );
};

export default Resources;
